import React, { useEffect } from 'react';
import Page from 'components/Page';
import { ReactComponent as DemoStaticDashboardIcon } from 'assets/icons/icon-monitor.svg';
import StatsBar from './StatsBar/StatsBar';
import Select from 'components/Select';

import PieChart from './LiquidityPieChart/PieChart';
import BarChart from './ExposureBarChart/BarChart';
import LineGraph from './BalanceHistoryLineGraph/LineGraph';
import pieData from './LiquidityPieChart/pieData';
import lineData from './BalanceHistoryLineGraph/lineData';
import barData from './ExposureBarChart/barData';
import DemoTable from 'components/DemoStaticDashboard/DemoTable/DemoTable';
import CornerRibbon from 'components/CornerRibbon/CornerRibbon';
import { useHasura } from 'context/ApiState';

const DemoStaticDashboard = () => {
  const { app_user } = useHasura();

  const hour = new Date().getHours();
  const greeting =
    'Good ' +
    ((hour < 12 && 'Morning') || (hour < 18 && 'Afternoon') || 'Evening');

  return (
    <Page
      title={`${greeting} ${app_user?.name?.split(' ')[0] || ''}`}
      icon={
        <DemoStaticDashboardIcon className="inline w-10 h-10 mr-2 -mb-1 -ml-2 text-gray-500" />
      }
    >
      <CornerRibbon position="top-right">Demo Data</CornerRibbon>

      <StatsBar />

      <div className="py-3 font-semibold text-center text-red-600 bg-red-100 rounded-lg">
        This data is for demonstration purposes only
      </div>

      <div className="flex flex-row items-start max-w-5xl">
        <div className="">
          <DemoTable />
        </div>

        <div className="flex-shrink-0 w-5 h-5" />

        <div className="flex-grow flex-shrink-0 p-5 bg-white border border-gray-400 rounded-lg shadow-sm">
          <h2 className="flex items-start justify-between mb-5 font-semibold text-gray-700">
            <span className="mr-5">Liquidity</span>
            <Select value="all" readOnly className="h-10">
              <option value="all">All Business Units</option>
            </Select>
          </h2>
          <PieChart data={pieData} />
        </div>
      </div>

      <div className="w-full p-5 bg-white border border-gray-400 rounded-lg shadow-sm">
        <h2 className="flex items-start justify-between mb-5 font-semibold text-gray-700">
          <span className="mr-5">Bank Exposure</span>
          <Select value="all" readOnly className="h-10">
            <option value="all">All Business Units</option>
          </Select>
        </h2>
        <BarChart data={barData} />
      </div>

      <div className="flex-grow p-5 pb-12 bg-white border border-gray-400 rounded-lg shadow-sm h-96">
        <h2 className="flex items-start justify-between mb-5 font-semibold text-gray-700">
          <span>Balance History</span>
        </h2>
        <LineGraph data={lineData} />
      </div>
    </Page>
  );
};

export default DemoStaticDashboard;
